module.exports = {
    // basic
    'supplement': 'supplement',
    'section-values': 'section values',
    'load-from-template': 'load from template',
    'dry-hole-cost': 'dry hole cost',
    'total-cost': 'total cost',
    'edit-files': 'edit files',
    'save-as-template': 'save as template',
    'costs': 'costs',
    'cost': 'cost',
    'attach-files': 'attach files',
    'step': 'step',
    'approver': 'approver',
    'values': 'values',
    'total': 'total',
    'note': 'note',
    'code': 'code',
    'supplementation-method': 'supplementation method',
    'supplementation-amount': 'supplementation amount',
    'original-result': 'original result',
    'new-result': 'new result',
    'result': 'result',
    'adjust': 'adjust',
    'recalculate': 'recalculate',
    'global-values': 'global values',
    'rounding': 'rounding',
    'load-cost-data-from-template': 'load cost data from template',
    'ready-for-approval': 'ready for approval',
    'entry': 'entry',
    'normal': 'normal',
    'both': 'both',
    'attached-to-well': 'attached to well',
    'lease': 'lease',
    'prospect': 'prospect',
    'description': 'description',
    'copy': 'copy',

    // raw
    'shl': 'SHL',
    'bhl': 'BHL',
    'search-by-afe': 'Search by AFE',
    'back-to-afe': 'Back to AFE',
    'afe': 'AFE',
    'template-afe': 'Template AFE',
    'download-afe': 'Download AFE',
    'add-afe': 'Add AFE',
    'review-original-afe': 'Review Original AFE',
    'save-afe-as-template': 'Save AFE As Template',
    'delete-afe': 'This AFE will be permanently deleted.\r\n\r\nContinue?',
    'save-afe-as-template-warning': `Clicking Save will save this AFE as template data.  This is not a normal AFE (has no approvals, triggers no alerts, etc).  It serves as a collection of saved AFE data which can be loaded into any normal non-template AFE.  It can still be edited at any time.  It cannot be converted back to a normal AFE.`,
    'load-afe-template-warning': `Clicking Ok will replace any entered costs with the value from the selected template.  If no value in the template exists, nothing will be replaced.  This change cannot be undone.`,
    'afe-global-value-other-section-in-use': 'Global values cannot be edited if any other sections have been opened by other users. The following other sections are currently open.',
    'afe-global-value-other-section-complete': 'Global values cannot be edited if any other sections are ready for approval. The following other sections are currently ready for approval.',
    'afe-global-value-calculation-warning': 'Some other sections have had some calculation work done. Editing any global value will cause other section totals to be cleared out and will need to be recalculated. Section values and line item values will remain preserved.',
    'afe-global-value-section-complete': 'Global values cannot be edited while this section is ready for approval.',
    'afe-section-value-section-complete': 'Section values cannot be edited while this section is ready for approval.',
    'reset-afe-section-line-items': 'This will reset all line item values back to zero. Continue?',
    'reset-afe-section-values': 'This will reset all section values back to zero. Continue?',
    'reset-afe-global-values': 'This will reset all global values back to zero. Continue?',
    'current-user-has-afe-sections-open-part-1': 'The following sections are currently still opened for edit by you, and therefore locked:',
    'current-user-has-afe-sections-open-part-2': 'As soon as you are finished editing these sections, please remember to click Save to remove the lock.',
    // template
    'opened-for-edit-by': (words) => `Opened for edit by ${words[0]} on ${words[1]}.`,
};
